import { Box, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { memo } from "react";
import { TemplatePage } from "../../0_TemplatePage/TemplatePage";

function NotFound() {
  return (
    <TemplatePage type="default">
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
        }}
      >
        <Box maxWidth={500}>
          {/* Optional image */}
          <Box
            component="img"
            src="/static/images/ksb-it/logoKSBIT.png"
            alt="404"
            sx={{
              width: 120,
              opacity: 0.8,
              mb: 3,
            }}
          />

          <Typography variant="h3" gutterBottom>
            404
          </Typography>

          <Typography variant="h5" color="text.secondary" gutterBottom>
            Diese Seite existiert nicht
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Vielleicht ist der Link falsch oder die Seite wurde verschoben.
          </Typography>

          <Button href="/" variant="contained" startIcon={<ArrowBackIcon />}>
            Zur Startseite
          </Button>
        </Box>
      </Box>
    </TemplatePage>
  );
}

export default memo(NotFound);
